import { Component, OnInit } from '@angular/core';
import { ITimeTracker, ITimeTrackingRecord, TimeTrackingService } from '../../services/time-tracking.service';
import { SessionService } from '../../services/session.service';
import { SHARED_MODULES } from '../../../shared.';
import { PhButtonComponent } from '../ph-button/ph-button.component';
import { PhIconWrapperComponent } from '../ph-icon-wrapper/ph-icon-wrapper.component';
import { TimeTrackerComponent } from '../time-tracker/time-tracker.component';

@Component({
    selector: 'app-timers-menu',
    templateUrl: './timers-menu.component.html',
    styleUrls: ['./timers-menu.component.scss'],
	imports: [SHARED_MODULES, PhButtonComponent, PhIconWrapperComponent, TimeTrackerComponent],
    standalone: true
})
export class TimersMenuComponent implements OnInit {
	timers: Map<string | number, ITimeTracker> = new Map<string | number, ITimeTracker>();

	constructor(
		public timeTrackingService: TimeTrackingService,
		private sessionService: SessionService
	) {}

	ngOnInit() {
		this.timers = this.timeTrackingService.timers;
		if (this.sessionService.isFramePage) return;
		if (!this.sessionService.defaults.isManager || !this.sessionService.defaults.planogramId) return;
		this.timeTrackingService.getAllTimers({
			execution_done: false,
			show_all: false
		}).subscribe((timers: Array<ITimeTrackingRecord>) => {
			timers.forEach((timer: ITimeTrackingRecord) => {
				this.timeTrackingService.setTimeTracking(timer);
			});
			this.timeTrackingService.timeTrackersInitSubject.next();
		})
	}

}
